import InboxPage from './InboxPage';

export default InboxPage;
